'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Link } from './Link';
import { useComponentDeprecation } from '../../util';

/**
 * @deprecated The MxLink will be removed in V5. Use Link component instead
 */
const MxLink = ({
  onClick,
  ...props
}) => {
  useComponentDeprecation({
    name: 'MxLink',
    alternative: 'Link',
    version: '5'
  });
  const handleOnClick = event => {
    onClick === null || onClick === void 0 || onClick(event);
    const {
      target
    } = props;
    if (!target || target === '_self') {
      window.location.href = props.href;
    }
  };
  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    onClick: handleOnClick,
    "data-aui": "link.mx"
  }));
};
export default MxLink;